<template>
  <div>
    <!-- 添加/编辑-类目： -->
    <el-dialog :title="isAdd ? $t('message.addCategory') : $t('message.editCategory')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="580px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 排序 -->
          <el-form-item :label="$t('message.sort')" prop="sort">
            <el-input v-model="ruleForm.sort" style="width: 100px;"></el-input>
            <span style="color: #c35257;">*数字越大越靠前</span>
          </el-form-item>
          <!-- icon -->
          <el-form-item label="icon">
            <el-upload :action="baseURL + '/api/common/uploadFile'" list-type="picture-card"
              :on-success="handleAvatarSuccess" :obefore-upload="beforeAvatarUpload" :show-file-list="false">
              <img v-if="ruleForm.icon" :src="ruleForm.icon" class="avatar" style="width: 100%;height: 100%;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span style="color: #c35257;"> *icon图标只能传一张</span>

          </el-form-item>
          <!-- status -->
          <el-form-item :label="$t('message.whetherEnabled')">
            <el-switch v-model="ruleForm.show">
            </el-switch>
            <span style="color: #c35257;"> *开关默认关闭，需要人工开启</span>
          </el-form-item>
          <!-- 类目名 -->
          <el-form-item :label="$t('message.categoryName')" prop="name">
            <el-input v-model="ruleForm.name" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="categoryStore" v-if="isAdd">{{
          $t("message.ok")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="categoryUpdate" v-else>{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    isAdd: { type: Boolean }
  },
  data() {
    return {
      ruleForm: {

      },
      dialogVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ]
      },
    };
  },
  methods: {
    // 新增
    categoryStore() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.ruleForm.is_show = this.ruleForm.show ? 1 : 0
          this.$api.siteConfiguration.categoryStore(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.guideArticleList()
          });
        }
      })

    },
    // 修改
    categoryUpdate() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.ruleForm.is_show = this.ruleForm.show ? 1 : 0
          this.$api.siteConfiguration.categoryUpdate(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.guideArticleList()
          });
        }
      })

    },
    acceptData(data) {
      this.ruleForm = data
      this.dialogVisible = true
    },
    // 上传
    handleAvatarSuccess(res) {
      this.ruleForm.icon = res.data
      this.$forceUpdate()
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;


}

/deep/ .avatar-uploader-icon {
  width: 120px;
  height: 120px;
  line-height: 120px;
}
</style>